/**
 * Removes persisted inventory metadata before using a record as a create-form draft.
 * Relations that users can edit, such as the preferred supplier, are intentionally kept.
 */
export const createInventoryDuplicateDraft = <T extends object>(source?: T): T | undefined => {
  if (!source) return undefined;

  const sourceRecord = source as T & Record<string, unknown>;
  const {
    id: _id,
    tenant: _tenant,
    createdAt: _createdAt,
    createdBy: _createdBy,
    updatedAt: _updatedAt,
    updatedBy: _updatedBy,
    clonedFromId: _clonedFromId,
    isTombstone: _isTombstone,
    migratedFromActivityId: _migratedFromActivityId,
    migratedToTransportId: _migratedToTransportId,
    recommendedActivities: _recommendedActivities,
    ...draft
  } = sourceRecord;

  return draft as T;
};
